import React, { useState, useCallback } from 'react'
import { TextField } from '@mui/material'
import Button from '@/components/Button'
import Text from '@/components/Text'
import { ConfirmButton } from '@/components/Button'
import { Row } from '../components'
import { secondaryText, primary } from '@/constant'
import CreateIcon from '@mui/icons-material/Create'

type valueType = string | number;

export interface EditableInfoProps {
  label: string;
  editable: boolean;
  value: valueType;
  onSave?: (value: valueType) => void;
  multiLine?: boolean;
}

export const EditableInfo: React.FC<EditableInfoProps> = (props) => {
  const { label, value, onSave, editable, multiLine } = props
  const [edit, setEdit] = useState<boolean>(false)
  const [formValue, setFormValue] = useState<valueType>()

  const handleSave = useCallback(() => {
    // @ts-ignore
    onSave(formValue)
    setEdit(false)
  }, [formValue, onSave])

  const handleEdit = useCallback(() => {
    setFormValue(value)
    setEdit(true)
  }, [value])

  const onCancel = useCallback(() => {
    setEdit(false)
  }, [])

  const onChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = event.target
    setFormValue(inputValue)
  }, [])

  return (
    <Row sx={{ gap: '32px', alignItems: 'center', lineHeight: '32px' }}>
      <Text
        size='sm'
        sx={{
          color: secondaryText,
          display: 'flex',
          alignItems: 'center',
          gap: '32px',
        }}
      >
        {label}
      </Text>
      {edit ? (
        <TextField
          label={label}
          multiline={multiLine}
          maxRows={3}
          rows={3}
          value={formValue}
          variant='outlined'
          size='small'
          InputProps={{
            sx: {
              width: '250px',
              '& .MuiOutlinedInput-notchedOutline': { borderColor: primary },
            },
          }}
          InputLabelProps={{
            sx: {
              '& .Mui-focused': { color: `${primary} !important` },
              color: `${primary} !important`,
            },
          }}
          onChange={onChange}
        />
      ) : (
        <Text size='xs' weight='regular'>
          {value}
        </Text>
      )}
      {edit ? (
        <Row>
          <ConfirmButton onClick={handleSave}>保存</ConfirmButton>
          <Button type='text' onClick={onCancel}>
            取消
          </Button>
        </Row>
      ) : (
        editable && (
          <Button type='text' startIcon={<CreateIcon />} onClick={handleEdit}>
            修改
          </Button>
        )
      )}
    </Row>
  )
}

export default EditableInfo
